const state = {
  noteShow: false,
  camShow: false,
  txtShow: false,
  micShow: false,
  drawShow: false,
};

// Stateのデータを変更するファンクション
const mutations = {
  setNoteShow: (state, noteshow) => (state.noteShow = noteshow),
  setCamShow: (state, camshow) => (state.camShow = camshow),
  setTxtShow: (state, txtshow) => (state.txtShow = txtshow),
  setMicShow: (state, micshow) => (state.micShow = micshow),
  setDrawShow: (state, drawshow) => (state.drawShow = drawshow),
};

// データの前処理
const actions = {
  // プロジェクトの追加ウィンドウの表示
  fetchNoteShow({state,commit}){
    if(state.noteShow != true){
      commit('setNoteShow', true);
    }
    else {
      commit('setNoteShow', false);
    }
  },
  fetchCamShow({state,commit}){
    if(state.camShow != true){
      commit('setCamShow', true);
    }
    else {
      commit('setCamShow', false);
    }
  },
  fetchTxtShow({state,commit}){
    if(state.txtShow != true){
      commit('setTxtShow', true);
    }
    else {
      commit('setTxtShow', false);
    }
  },
  fetchMicShow({state,commit}){
    if(state.micShow != true){
      commit('setMicShow', true);
    }
    else {
      commit('setMicShow', false);
    }
  },
  fetchDrawShow({state,commit}){
    if(state.micShow != true){
      commit('setDrawShow', true);
    }
    else {
      commit('setDrawShow', false);
    }
  },
};

// データの抽出：これでDOM上でGettersのデータを使用できる !!データの変更はMUTATIONから!!
const getters = {
  noteshow: state => state.noteShow,
  camshow: state => state.camShow,
  txtshow: state => state.txtShow,
  micshow: state => state.micShow,
  drawshow: state => state.drawShow,
};

export default {
  state,
  getters,
  actions,
  mutations,
};